function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as R from "ramda";
import { useCallback, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { config } from "../../config";
import { useAuth, useDialogs } from "../../hooks";
import { AuthServiceProvider, Emitter } from "../../services";
import { ERROR_CODES } from "../../types";
import { getAccountId, getLogger } from "../../utils";
var log = getLogger("Security");
/**
 * Application won't work without accountId. It should be provided as query param
 * and will be stored to localStorage.
 */ var redirectIfNoAccountId = function(accountId) {
    var hostPage = config.nexmoDashboardHost;
    var appName = localStorage.getItem("vch.app_name");
    if (!accountId && appName === "customer" && hostPage) {
        window.location.replace(hostPage);
    }
    return accountId;
};
export var Security = function(param) {
    var accountId = param.accountId, children = param.children, _param_skipAuth = param.skipAuth, skipAuth = _param_skipAuth === void 0 ? false : _param_skipAuth;
    var openConfirmDialog = useDialogs().openConfirmDialog;
    var _useAuth = useAuth(), saveAccountId = _useAuth.saveAccountId, shouldValidateAuthentication = _useAuth.shouldValidateAuthentication;
    var _useSearchParams = _sliced_to_array(useSearchParams(), 2), searchParams = _useSearchParams[0], setSearchParams = _useSearchParams[1];
    var location = useLocation();
    var hash = location.hash, pathname = location.pathname;
    var register = searchParams.get("register");
    useEffect(function() {
        var _searchParams_get;
        R.pipe(getAccountId, redirectIfNoAccountId, saveAccountId)((_searchParams_get = searchParams.get("accountId")) !== null && _searchParams_get !== void 0 ? _searchParams_get : accountId);
    }, [
        accountId,
        saveAccountId,
        searchParams
    ]);
    useEffect(function() {
        var handleRegister = function() {
            var _ref = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                new AuthServiceProvider().isAuthenticated()
                            ];
                        case 1:
                            if (_state.sent()) {
                                log.info("User is authenticated.");
                                searchParams.delete("register");
                                setSearchParams(searchParams);
                            } else {
                                log.info("Authenticating user...");
                                new AuthServiceProvider().login();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRegister() {
                return _ref.apply(this, arguments);
            };
        }();
        if (register) {
            handleRegister();
        }
    }, [
        register,
        searchParams,
        setSearchParams
    ]);
    useEffect(function() {
        log.info("Skip authentication: ".concat(Boolean(skipAuth)));
        shouldValidateAuthentication(Boolean(skipAuth));
    }, [
        shouldValidateAuthentication,
        skipAuth
    ]);
    var handleSessionExpired = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _ref, shouldRefreshSession;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        openConfirmDialog({
                            cancelLabel: "Later",
                            confirmLabel: "Refresh session now",
                            message: "Please check your access rights, contact support or try refreshing your session.",
                            title: "Forbidden"
                        })
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        1
                    ]), shouldRefreshSession = _ref[0];
                    if (shouldRefreshSession) {
                        localStorage.setItem("vch.navigate_to", pathname + hash);
                        localStorage.removeItem("vch.auth");
                        new AuthServiceProvider().login();
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        hash,
        openConfirmDialog,
        pathname
    ]);
    useEffect(function() {
        if (skipAuth) return;
        var showErrorDialog = function() {
            var _ref = _async_to_generator(function(error) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(error.code === ERROR_CODES.denied)) return [
                                3,
                                2
                            ];
                            Emitter.off("error", showErrorDialog);
                            return [
                                4,
                                handleSessionExpired()
                            ];
                        case 1:
                            _state.sent();
                            Emitter.on("error", showErrorDialog);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function showErrorDialog(error) {
                return _ref.apply(this, arguments);
            };
        }();
        Emitter.on("error", showErrorDialog);
        return function() {
            Emitter.off("error", showErrorDialog);
        };
    }, [
        handleSessionExpired,
        skipAuth
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};

//# sourceMappingURL=Security.js.map